<template>
	<list type="end" typeid="" keyword=""></list>
</template>
<script>
import list from "@/components/index/list";
export default {
  name: "end",
  components: {
    list
  }
};
</script>


// WEBPACK FOOTER //
// src/components/index/end.vue